import React from 'react';

export const formData = {
  mainTitle: 'Subscribe to our newsletter',
  description: <>Sign up to our Networks&apos;n&apos;Cloud Insider and get the latest news from us once a month</>,
  thankYouTitle: 'Thank you for subscribing!',
  thankYouNote: 'Check your email box and discover what we have prepared for you!',
};
